module.exports = __webpack_public_path__ + "static/media/meter3.a2c9309e.svg";